// Mock data for testing when backend endpoints are not available
export const mockPurchaseOrders = [
  {
    id: 1,
    vendor_id: 1,
    purchase_date: "2024-01-15",
    total_amount: 1500.0,
    payment_status: "paid",
    invoice_number: "INV-001",
    created_at: "2024-01-15T10:00:00Z",
    purchase_items: [
      {
        id: 1,
        product_id: 1,
        quantity_purchased: 10,
        purchase_price_per_unit: 15.0,
        total_price: 150.0,
      },
    ],
  },
  {
    id: 2,
    vendor_id: 2,
    purchase_date: "2024-01-16",
    total_amount: 2300.0,
    payment_status: "unpaid",
    invoice_number: "INV-002",
    created_at: "2024-01-16T14:30:00Z",
    purchase_items: [
      {
        id: 2,
        product_id: 2,
        quantity_purchased: 5,
        purchase_price_per_unit: 25.0,
        total_price: 125.0,
      },
    ],
  },
];

export const mockStockAdjustments = [
  {
    id: 1,
    product_id: 1,
    adjustment_type: "increase",
    quantity: 10,
    reason: "purchase",
    date: "2024-01-15",
    created_at: "2024-01-15T10:00:00Z",
  },
  {
    id: 2,
    product_id: 2,
    adjustment_type: "decrease",
    quantity: 2,
    reason: "damage",
    date: "2024-01-16",
    created_at: "2024-01-16T14:30:00Z",
  },
];

export const mockLowStockProducts = [
  {
    id: 1,
    name: "Sample Product 1",
    stock_quantity: 5,
    unit: "piece",
  },
  {
    id: 2,
    name: "Sample Product 2",
    stock_quantity: 3,
    unit: "kg",
  },
];

export const mockProducts = [
  {
    id: 1,
    name: "Fresh Tomatoes",
    price: 2.5,
    stock_quantity: 25,
    unit: "kg",
    category_id: 1,
    sub_category_id: 1,
    status: "active",
  },
  {
    id: 2,
    name: "Organic Carrots",
    price: 1.8,
    stock_quantity: 15,
    unit: "kg",
    category_id: 1,
    sub_category_id: 1,
    status: "active",
  },
  {
    id: 3,
    name: "Green Lettuce",
    price: 3.2,
    stock_quantity: 8,
    unit: "piece",
    category_id: 1,
    sub_category_id: 2,
    status: "active",
  },
  {
    id: 4,
    name: "Red Bell Peppers",
    price: 4.5,
    stock_quantity: 12,
    unit: "kg",
    category_id: 1,
    sub_category_id: 1,
    status: "active",
  },
  {
    id: 5,
    name: "Fresh Basil",
    price: 2.0,
    stock_quantity: 6,
    unit: "bunch",
    category_id: 1,
    sub_category_id: 2,
    status: "active",
  },
];

export const mockInventoryOverview = {
  totalProducts: 25,
  totalStockValue: 15000.0,
  totalQuantity: 500,
};

export const mockVendors = [
  {
    id: 1,
    user_id: 1,
    business_name: "Fresh Farm Supplies",
    contact_person: "John Smith",
    email: "john@freshfarm.com",
    phone: "+1-555-0123",
    address: "123 Farm Road, Agriculture City",
    status: "approved",
    created_at: "2024-01-01T00:00:00Z",
  },
  {
    id: 2,
    user_id: 2,
    business_name: "Green Valley Produce",
    contact_person: "Sarah Johnson",
    email: "sarah@greenvalley.com",
    phone: "+1-555-0456",
    address: "456 Valley Street, Green City",
    status: "approved",
    created_at: "2024-01-02T00:00:00Z",
  },
  {
    id: 3,
    user_id: 3,
    business_name: "Organic Harvest Co.",
    contact_person: "Mike Brown",
    email: "mike@organicharvest.com",
    phone: "+1-555-0789",
    address: "789 Organic Lane, Eco Town",
    status: "approved",
    created_at: "2024-01-03T00:00:00Z",
  },
];
